import { useState, useEffect } from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

import * as apiComms from '../apiComms';
import * as logger from '../logger';
import * as dayjs from 'dayjs'

const PROG = 'ChartRepeatPurchaseRatePerDay.js';

const ChartRepeatPurchaseRatePerDay = (props) => {

  const [chartData, setChartData] = useState(null);
  const [isLoadingData, setIsLoadingData] = useState(true);

  useEffect(() => {
    const loadChartData = async () => {
      const FUNCTION = 'loadChartData';
      try {
        setIsLoadingData(true);
        const _chartDataResponse = await apiComms.getChartDataRepeatPurchaseRatePerDay(props.timeRange);
        if (_chartDataResponse && !_chartDataResponse.isErr) {
          const _chartData = _chartDataResponse.response.chartdata;
          const _chartDataDateParsed = _parseChartDataDates(_chartData);
          setChartData(_chartDataDateParsed);
        }
        setIsLoadingData(false);
      }
      catch (e) {
        logger.error('Exception Occured', { PROG, FUNCTION });
        console.log('Exception: '+e+', '+e.stack);
      }
    };

    loadChartData();
  }, [props.timeRange]);

  const _parseChartDataDates = (_chartData) => {
    let _parsedChartData = [];
    _chartData.forEach((_chartDataRec) => {
      const _chartDateEpoch = (_chartDataRec.x*1000);
      const _chartDateDayJs = dayjs(_chartDateEpoch);
      const _chartDateReadable = _chartDateDayJs.format('DD/MMM/YYYY');
      _parsedChartData.push({
        date : _chartDateReadable,
        oneTimeCustomers : Number(_chartDataRec.oneTimeCustomers ?? 0),
        repeatCustomers : Number(_chartDataRec.repeatCustomers ?? 0)
      });
    });

    return _parsedChartData;
  };

  return (
    <div className='card'>
      <div style={{ display : 'flex', width : '100%', flexDirection : 'column', borderRadius: 10, overflow : 'hidden' }} >
        <div style={{ height : 280 }}>
          {!isLoadingData ? (
            <>
            {Array.isArray(chartData) && chartData.length > 0 ? (
            <ResponsiveContainer>
              <AreaChart
                data={chartData}
                margin={{ top: 20, right: 20, left: 6, bottom: 0 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="date"
                  angle={45}
                  textAnchor="start"
                  height={60}
                  tick={{ fontSize: 10 }}
                />
                <YAxis width={42} />
                <Tooltip />
                <Legend />
                <Area
                  type="monotone"
                  dataKey="oneTimeCustomers"
                  stackId="customers"
                  stroke="#adb5bd"
                  fill="#adb5bd"
                  fillOpacity={0.75}
                  name="One-Time Customers"
                />
                <Area
                  type="monotone"
                  dataKey="repeatCustomers"
                  stackId="customers"
                  stroke="#20c997"
                  fill="#20c997"
                  fillOpacity={0.82}
                  name="Repeat Customers"
                />
              </AreaChart>
            </ResponsiveContainer>
            ) : null }
            </>
          ) : null }
        </div>
        <div className='card-body'>
          Repeat Purchase Rate Over Time
        </div>
      </div>
    </div>
  );
};

export default ChartRepeatPurchaseRatePerDay;
